<template>
  <v-card
    class="app-card app-card--without-border app-card--without-margin-bottom"
  >
    <v-card-title class="app-card-title" primary-title>
      Nova Autorização
    </v-card-title>
    <v-card-text class="app-card-content pr-0 pl-0 pb-0">
      <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
        <v-col :md="12" :sm="12" :xs="12" cols="12">
          <v-alert text outlined type="error" v-if="error.show">
            {{ error.message }}
          </v-alert>
          <v-select
            v-model="form.taxaId"
            :rules="[rules.required]"
            :items="taxas"
            item-text="descricaoFormatado"
            item-value="id"
            label="Licença*"
            placeholder="Selecione o tipo da licença"
            filled
            dense
            rounded
          ></v-select>

          <AutorizacaoTermos @acept="notAgree = !$event"/>

        </v-col>
        <div class="loading" v-if="isLoading">
          <v-progress-circular
            :size="25"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <v-divider></v-divider>
        <v-card-actions class="app-card-actions">
          <v-btn depressed color="error" type="button" @click="closeDialog"
            >Cancelar</v-btn
          >
          <v-btn type="submit" :disabled="notAgree" depressed color="#3eb355" class="white--text">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import LicencaEspecialService from "@/services/licencaEspecial.service";
import AutorizacaoTermos from "./AutorizacaoTermos";
import GlobalStore from "@/store/modules/global";

export default {
  name: "AutorizacaoForm",
  props: { veiculoTransportadoraId: Number },
  components: {
    AutorizacaoTermos
  },
  data() {
    return {
      taxas: null,
      isLoading: false,
      notAgree: true,
      form: {
        taxaId: null,
        veiculoTransportadoraId: null
      },
      error: {
        message: null,
        show: false
      },
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido"
      }
    };
  },
  methods: {
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        LicencaEspecialService.criarAutorizacaoFretamento(
          this.form.veiculoTransportadoraId,
          this.form.taxaId
        ).subscribe(
          res => {
            this.isLoading = false;
            this.error.show = false;
            this.closeDialog({
              type: "success",
              message: "Autorização criada com sucesso!"
            });
          },
          error => {
            this.error.message = error;
            this.error.show = true;
            this.isLoading = false;
          }
        );
      }
    },
    loadTaxas() {
      LicencaEspecialService.listarTodasTaxasFretamento(
        this.veiculoTransportadoraId
      ).subscribe(
        res => {
          this.taxas = res;
          this.error.show = false;
        },
        error => {
          this.error.message = error;
          this.error.show = true;
        }
      );
    },
    initData() {
      this.form.veiculoTransportadoraId = this.veiculoTransportadoraId;
    },
    closeDialog(event = { type: "close", message: "" }) {
      this.$emit("closeDialog", event);
    }
  },
  mounted() {
    this.loadTaxas();
    this.initData();
  }
};
</script>
